module.exports = __webpack_public_path__ + "static/media/speaker.bdb761f2.svg";